import { useEffect, useState } from 'react'
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Skeleton from '../../components/ui/Skeleton';


const FaqsPublic = () => {
    const [data, setData] = useState([])
    const faq_get = useMakeRequest();

    useEffect(() => {
        faq_get.makeRequest({ url: ApiConstants?.FaqGet })
    }, []);

    useEffect(() => {
        if (faq_get?.data?.data?.rows) {
            const fallingFaqs = faq_get.data.data.rows.filter((item: any) => item.showing_on_landing_page === 1);
            setData(fallingFaqs)
        }
    }, [faq_get?.data?.data?.rows]);

    return (
        <div className="faq-public">
            <h1 className="mb-4 text-center">Frequently Asked Questions</h1>

            <div className="accordion mt-4 faq-accordian" id="faqAccordion">
                {faq_get?.loading ? (
                    <>
                        <Skeleton className='skeleton-loader mt-5' style={{ width: '100%', height: '30px' }} />
                        <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                        <Skeleton className='skeleton-loader my-2' style={{ width: '65%', height: '20px' }} />
                        <Skeleton className='skeleton-loader my-2' style={{ width: '70%', height: '20px' }} />
                        <Skeleton className='skeleton-loader my-2' style={{ width: '75%', height: '20px' }} />

                        <Skeleton className='skeleton-loader mt-3' style={{ width: '100%', height: '30px' }} />
                        <Skeleton className='skeleton-loader mt-3' style={{ width: '100%', height: '30px' }} />
                    </>
                ) : ''}

                {data?.length > 0 && data?.map((item: any, index: any) => {
                    return (
                        <div className="accordion-item text-break" key={index}>
                            <h2 className="accordion-header" id={`faqHeader${index}`}>
                                <button
                                    className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#faqCollapse${index}`}
                                    aria-expanded={index === 0 ? "true" : "false"}
                                    aria-controls={`faqCollapse${index}`}
                                >
                                    {item?.question}
                                </button>
                            </h2>

                            <div
                                id={`faqCollapse${index}`}
                                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                aria-labelledby={`faqHeader${index}`}
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="accordion-body">
                                    {item?.answer}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default FaqsPublic;
